import HTTPService        from "@/js/Shared/Services/HTTP/HTTPService.js";
import HTTPResponseEntity from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import SAPOMailConfig     from "@/SAPOMailConfig";

export { IMAPOptionsHTTPService as default };

/**
* Imap Security HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IMAPOptionsHTTPService {
  /**
   * Imap Security Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.imp;

  /**
   * Makes an HTTP Request to fetch imap security options to the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetch() {
    let request = {
      op: 'imapSettings',
    }

    let response = await HTTPService.post(
      this.endpoint + '/security',
      request,
      'imap_options_fetch'
    );

    return response;
  }

  /**
   * Makes an HTTP Request to enable imap in the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
   async enable() {
    let request = {
      op: 'imapEnable',
    }

    let response = await HTTPService.post(
      this.endpoint + '/security',
      request,
    );

    return response
  }

  /**
   * Makes an HTTP Request to disable imap in the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
   async disable() {
    let request = {
      op: 'imapDisable',
    }

    let response = await HTTPService.post(
      this.endpoint + '/security',
      request,
    );

    return response
  }
}